"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var chars = '0123456789abcdef'.split('');

var _default = function _default() {
  var id = [];

  for (var i = 0; i < 32; i++) {
    id.push(chars[Math.floor(Math.random() * chars.length)]);
  }

  id.splice(8, 0, '-');
  id.splice(13, 0, '-');
  id.splice(18, 0, '-');
  id.splice(23, 0, '-');
  return id.join('');
};

exports.default = _default;
module.exports = exports.default;